<template>
    <div id="cardDetails">
        <div class="section1">
            <el-form :inline="true" ref="cardDetailsForm" @submit.native.prevent :model="cardDetailsForm"
                :rules="cardDetailsRules">
                <el-form-item prop="iccid">
                    <el-input v-model.trim="cardDetailsForm.iccid"
                        @keyup.enter.native="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)" placeholder="请输入卡号"
                        v-focus clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain
                        @click="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <template v-if="showDetail">
            <div class="section2">
                <h4>基本信息</h4>
                <el-row>
                    <el-col :span="6">
                        <img v-show="cardInfo.supplierTypeCode == 3" style="width:120px" src="./../../assets/img_yidong.png"
                            alt="">
                        <img v-show="cardInfo.supplierTypeCode == 9" style="width:120px"
                            src="./../../assets/img_liantong.png" alt="">
                        <img v-show="cardInfo.supplierTypeCode == 1 || cardInfo.supplierTypeCode == 5" style="width:120px"
                            src="./../../assets/img_dianxin.png" alt="">
                    </el-col>
                    <el-col :span="18">
                        <el-row>
                            <el-col :span="8">ICCID号：
                                <el-tooltip effect="dark" content="点击查看流量轮询详情" placement="top">
                                    <a href="javascript:void(0);" @click="toFluxPollDetail(cardInfo.iccid)">{{
                                        cardInfo.iccid }}</a>
                                </el-tooltip>
                                <span @click="copyOrderId()" class="copy_url" :data-clipboard-text="cardInfo.iccid"
                                    style="color: #409EFF;padding-left: 20px;cursor: pointer;">复制</span>

                            </el-col>
                            <el-col :span="8"
                                v-if="cardInfo.supplierName && cardInfo.supplierName.indexOf('运城') == 0 && cardInfo.cardState == 11">
                                <span style="font-size: 28px; color: red;"> 供应商： {{ cardInfo.supplierName }}</span>
                            </el-col>
                            <el-col :span="8" v-else>供应商： {{ cardInfo.supplierName }}</el-col>
                            <el-col :span="8">通道： {{ cardInfo.alias }}</el-col>

                        </el-row>
                        <el-row>
                            <el-col :span="8">接入号： {{ cardInfo.intoNo }}</el-col>
                            <el-col :span="8">虚拟号： {{ cardInfo.virtualNo }}</el-col>
                            <el-col :span="8">用户位置： {{ cardInfo.userCity }}</el-col>
                            <el-col :span="8">套餐组： {{ cardInfo.basePkgGroupName }}</el-col>
                            <el-col :span="8">代理商: {{ cardInfo.agentName }}</el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="8">车联网实名： {{ cardInfo.isUserAuth }}</el-col>
                            <el-col :span="8">姓名： {{ cardInfo.userName }}</el-col>
                            <el-col :span="8">手机号： {{ cardInfo.userPhone }}</el-col>
                            <el-col :span="8">身份证: {{ cardInfo.idCard }}</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">优惠券： {{ cardInfo.priceName }}</el-col>
                            <el-col :span="8">卡余额： {{ cardInfo.simAmount }} /元</el-col>

                            <el-col :span="8">
                                <el-col :span="24"
                                    v-if="cardInfo.supplierName && cardInfo.supplierName.indexOf('运城') == 0 && cardInfo.cardState == 11">
                                    <span style="font-size: 28px; font-weight:blod; color: red;"> 卡状态：{{
                                        cardInfo.cardStateName }}</span>
                                </el-col>

                                <el-col :span="12" v-else>卡状态：
                                    <span class="font-defined dark" v-if="cardInfo.cardState == 1"> {{
                                        cardInfo.cardStateName }}</span>
                                    <span class="font-defined green" v-else-if="cardInfo.cardState == 2">{{
                                        cardInfo.cardStateName }}</span>
                                    <span class="font-defined red" v-else-if="cardInfo.cardState == 4"> {{
                                        cardInfo.cardStateName }}</span>
                                    <span class="font-defined" v-else> {{ cardInfo.cardStateName }}</span>
                                </el-col>

                            </el-col>

                            <el-col :span="8" v-if="cardInfo.flowRatePercent != null">
                                可使用流量比： <span class="font-defined">{{ cardInfo.flowRatePercent }} %</span>
                            </el-col>
                        </el-row>


                        <el-row>
                            <el-col :span="16"
                                v-if="cardInfo.supplierName && cardInfo.supplierName.indexOf('运城') == 0 && cardInfo.cardState == 11">
                                <span
                                    style="display:inline-block; color: red; font-size: 24px; transform: translateY(100px);"
                                    class="text-animation-default">变更卡状态备注： {{ cardInfo.changeStateRemark }}</span>
                            </el-col>
                            <el-col :span="16" v-else>变更卡状态备注： {{ cardInfo.changeStateRemark }}</el-col>



                            <el-col :span="8">
                                <el-button type="primary" size="mini"
                                    @click="updateStateHandler(cardInfo.iccid, true)">刷新</el-button>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="16">卡备注：
                                <el-input v-model="cardInfo.remark" style="width: 40%; vertical-align: middle;" />
                                <el-button style="margin-left: 5px; height: 32px;"
                                    @click="updateLimitNumber(cardInfo.iccid)">修改备注</el-button>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
            </div>
            <!-- 套餐详情区域优化 -->
            <div class="section3">
                <h4>套餐详情</h4>
                <div>
                    <!-- 控制折叠/展开的核心逻辑 -->
                    <div v-for="(item, index) in (isExpandAll ? cardInfo.simPackageList : cardInfo.simPackageList.slice(0, 4))"
                        :key="item.id" style="margin-bottom:40px;">
                        <h5>
                            <span class="span-defined">订单号：{{ item.id }}</span>
                            套餐名称：{{ item.packageName }}
                        </h5>
                        <el-row>
                            <el-col :span="7" class="progressOuter">
                                <el-progress :stroke-width="8" :percentage="item.usedFlowRate / item.flowRate * 100"
                                    :show-text="false"></el-progress>
                                <div v-if="item.state != 1">
                                    <div class="fr">剩余：{{ decrease(fluxMtoG(item.flowRate), fluxMtoG(item.usedFlowRate)) }}G
                                    </div>
                                    <div>已用：{{ fluxMtoG(item.usedFlowRate) }}G / {{ fluxMtoG(item.flowRate) }}G</div>
                                </div>
                                <div v-else>
                                    <div class="fr">剩余：{{ decrease(item.flowRate, item.usedFlowRate) }}分钟</div>
                                    <div>已用：{{ item.usedFlowRate }}分钟 / {{ item.flowRate }}分钟</div>
                                </div>
                            </el-col>
                            <el-col :span="6" style="text-align: center;">
                                <p v-if="item.state == 4" class="progressOuter pOuter" style="color: red;">退款中</p>
                                <p v-else-if="item.state == 3" class="progressOuter pOuter" style="color: red;">已退款</p>
                                <p v-if="item.state == 1">
                                    已用（真）：{{ item.usedFlowRate }} 分钟
                                </p>
                                <p v-else>
                                    已用（真）：{{ fluxMtoG(item.usedRealFlowRate) }}G
                                </p>
                            </el-col>
                            <el-col :span="4">流量百分比：{{ item.flowRatePercent }}%</el-col>
                            <el-col :span="5">
                                <p class="progressOuter pOuter">生效时间：{{ item.startTime }}</p>
                                <p v-if="isExpiredTime(item.endTime)" style="color: red;">过期时间：{{ item.endTime }}</p>
                                <p v-else>过期时间：{{ item.endTime }}</p>
                            </el-col>
                            <el-col :span="2">
                                <el-button @click="showChangePkgEndTimeHandler(item)">修改过期时间</el-button>
                            </el-col>
                            <el-col :span="2">
                                <el-button @click="showChangePkgEndTimeHandler1(item)">修改套餐流量</el-button>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 折叠/展开按钮 -->
                    <div v-if="cardInfo.simPackageList.length > 4" style="margin: 10px 0; text-align: center;">
                        <el-button type="text" @click="isExpandAll = !isExpandAll" style="color: #409EFF;">
                            {{ isExpandAll ? '收起' : `查看更多（共${cardInfo.simPackageList.length}个套餐）` }}
                        </el-button>
                    </div>

                    <!-- 流量统计汇总 -->
                    <div style="margin-top: -30px; font-size: 16px; font-weight: 600;" v-show="getSum > 0">
                        <el-row>
                            <el-col :span="7">&nbsp;</el-col>
                            <el-col :span="8" style="text-align: center;">
                                本月已用流量：{{ cardInfo.monthTotal ? fluxMtoG(cardInfo.monthTotal) : 0 }} G；&nbsp;
                                总计已用流量：{{ getSum }} G
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="section4">
                <h4>操作管理</h4>
                <div>
                    <el-button size="normal" @click="showAddPkg" icon="el-icon-edit">添加套餐</el-button>
                    <el-button size="normal" @click="stopSimHandler" plain icon="el-icon-s-ticket">停机</el-button>
                    <el-button size="normal" @click="resetSimHandler" plain icon="el-icon-s-ticket">复机</el-button>
                    <el-button size="normal" @click="selectStopResult" plain icon="el-icon-s-ticket">停机原因查询</el-button>
                    <el-button size="normal" @click="stateRecordListHandler" icon="el-icon-search">停复机记录</el-button>
                    <el-button size="normal" @click="noBIndSIm" icon="el-icon-s-ticket">机卡解绑</el-button>
                    <el-button size="normal" @click="activeNo" icon="el-icon-s-ticket">广电机卡分离复机</el-button>
                    <el-button size="normal" @click="showToNewCardHandler" icon="el-icon-s-ticket">老卡转新卡</el-button>
                    <el-button size="normal" @click="simDiagnosisHandler" icon="el-icon-s-ticket">刷新复机</el-button>
                    <el-button size="normal" @click="getFluxDetailListHandler" icon="el-icon-search">流量使用情况 </el-button>
                    <el-button size="normal" @click="showChangePkgGoupHandler" icon="el-icon-s-ticket">变更套餐组 </el-button>
                    <el-button size="normal" @click="showChangeCardStateHandler" icon="el-icon-s-ticket">变更卡状态 </el-button>
                    <el-button size="normal" @click="showAddRealNameSearch" icon="el-icon-search">实名查询 </el-button>
                    <el-button size="normal" @click="resetFlow" plain icon="el-icon-s-ticket">重置流量</el-button>
                    <el-button size="normal" @click="showChangeCardStateHandler1" icon="el-icon-edit">添加赠送金</el-button>
                    <el-button size="normal" @click="stateRecordListHandler1" icon="el-icon-search">赠送金记录</el-button>
                    <el-button size="normal" @click="showToNewCard1" plain icon="el-icon-s-ticket">增加账户余额</el-button>
                    <el-button size="normal" @click="showToNewCard12" plain icon="el-icon-delete">删除卡数据</el-button>
                    <el-button size="normal" @click="showToNewCard123" plain icon="el-icon-delete">删除实名缓存</el-button>
                    <el-button size="normal" @click="showToNewCard124" plain icon="el-icon-delete">删除超流量</el-button>
                    <el-button size="normal" @click="showToNewCard125" plain icon="el-icon-delete">删除手机绑定</el-button>
                    <el-button size="normal" @click="showToNewCard126" plain icon="el-icon-delete">删除绑定限制</el-button>
                    <el-button size="normal" @click="showToNewCard127" plain icon="el-icon-delete">删除所有套餐</el-button>
                </div>
            </div>
            <div class="section5">
                <h4>往期订单</h4>
                <el-table :data="tableData" border>
                    <el-table-column prop="orderNo" width="240" label="订单号"></el-table-column>
                    <el-table-column prop="packageName" width="120" label="套餐名称"></el-table-column>
                    <el-table-column prop="packageTypeName" width="120" label="套餐类型"></el-table-column>
                    <el-table-column label="套餐流量" width="120">
                        <template slot-scope="scope">
                            <span>{{ fluxMtoG(scope.row.flowRate) }}G</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" width="160" label="订购时间"></el-table-column>
                    <el-table-column prop="createTypeName" width="120" label="订购类型"></el-table-column>
                    <el-table-column prop="isNextMonthName" width="120" label="生效时间"></el-table-column>
                    <el-table-column label="备注">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" clearable
                                @blur="modifyOrderInfoHandler(scope.row)"></el-input>
                            <!-- <a href="javascript:void(0)" @click="showOrderDetailHandler(scope.row)">{{scope.row.remark}}</a>     -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </template>

        <el-dialog :append-to-body="true" title="修改过期时间" :visible.sync="endTimeVisible" width="600px" @close="endTimecancel"
            :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
                <el-form-item label="修改方式：" prop="type">
                    <el-select v-model="endTimeForm.type">
                        <el-option value="1" label="指定过期时间">指定过期时间</el-option>
                        <el-option value="2" label="指定延长天数"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原过期时间：">
                    <div>{{ endTimeForm.oldTimeString }}</div>
                </el-form-item>
                <el-form-item v-if="endTimeForm.type == 1" label="新开始时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newEndString" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item v-if="endTimeForm.type == 1" label="新过期时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newTimeString" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item v-else label="延长天数：" prop="dayNum">
                    <el-input v-model="endTimeForm.dayNum" placeholder="请输入天数" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="endTimeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="修改流量信息" :visible.sync="endTimeVisible1" width="600px"
            @close="endTimecancel1" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">

                <el-form-item label="已使用流量：" prop="use">
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="endTimeForm.use" clearable></el-input-number> GB
                    </el-col>
                </el-form-item>
                <el-form-item label="总流量：" prop="total">
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="endTimeForm.total" clearable></el-input-number>GB
                    </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel1">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler1">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="新增套餐" :visible.sync="addPkgVisible" width="600px" @close="addPkgCancel"
            :close-on-click-modal="false">
            <el-form ref="addPkgForm" :model="addPkgForm" :rules="addPkgRules" label-width="130px">
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-radio-group v-model="addPkgForm.packageId" class="pkgName" @change="changeAddPkgFormItem">
                        <el-radio v-for="item in pkgList" :key="item.id" :label="item.id" style="padding: 10px 0;">
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth" v-if="addPkgFormIsNextMonth">
                    <el-select v-model="addPkgForm.isNextMonth">
                        <el-option value="0" label="本月生效">本月生效</el-option>
                        <el-option value="1" label="次月生效">次月生效</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="购买上游套餐：" prop="toBuy">
                    <el-radio-group v-model="addPkgForm.toBuy">
                        <el-radio :label="2">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="addPkgForm.remark" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddPkgHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="转新卡" :visible.sync="toNewCardVisible" width="600px"
            @close="toNewCardCancel" :close-on-click-modal="false">
            <el-form ref="toNewCardForm" :model="toNewCardForm" :rules="toNewCardRules" label-width="120px">
                <el-form-item label="新卡ICCID/虚拟号：" prop="iccid">
                    <el-input v-model.trim="toNewCardForm.iccid" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="moveType">
                    <el-radio-group v-model="toNewCardForm.moveType">
                        <el-radio label="1">全部</el-radio>
                        <el-radio label="2">仅转流量</el-radio>
                        <el-radio label="3">仅转层级</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="toNewCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="toNewCardCancel">取 消</el-button>
                <el-button type="primary" @click="sureToNewCardHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="停复机记录" :visible.sync="stateRecordVisible" width="80%"
            :close-on-click-modal="false">
            <el-table :data="tableData_record" border height="421">
                <el-table-column prop="stateName" label="操作类型"></el-table-column>
                <el-table-column prop="createTypeName" label="操作来源"></el-table-column>
                <el-table-column prop="createTime" label="操作时间"></el-table-column>
                <el-table-column prop="createOptName" label="操作人"></el-table-column>
                <el-table-column prop="failReason" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChangeRecord" @current-change="handleCurrentChangeRecord"
                :current-page="currentPage_record" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize_record"
                layout="total, sizes, prev, pager, next, jumper" :total="total_record">
            </el-pagination>
        </el-dialog>


        <el-dialog :append-to-body="true" title="赠送金记录" :visible.sync="stateRecordVisible1" width="80%"
            :close-on-click-modal="false">
            <el-table :data="tableData_record1" border height="421">
                <el-table-column prop="iccid" label="卡号"></el-table-column>
                <el-table-column prop="orderNo" label="订单号"></el-table-column>
                <el-table-column prop="name" label="券名称"></el-table-column>
                <el-table-column prop="stateName" label="券状态"></el-table-column>
                <el-table-column prop="endTime" label="券过期时间"></el-table-column>
                <el-table-column prop="pkgNmae" label="已兑换套餐"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChangeRecord1" @current-change="handleCurrentChangeRecord1"
                :current-page="currentPage_record1" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize_record1"
                layout="total, sizes, prev, pager, next, jumper" :total="total_record1">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" title="流量使用详情" :visible.sync="fluxVisible" width="80%"
            :close-on-click-modal="false">
            <el-table :data="tableData_flux" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column label="本月已用流量（G）">
                    <template slot-scope="scope">
                        <span>{{ fluxMtoG(scope.row.monthTotal) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="查询时间 "></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChangeFlux" @current-change="handleCurrentChangeFlux"
                :current-page="currentPage_flux" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize_flux"
                layout="total, sizes, prev, pager, next, jumper" :total="total_flux">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" title="变更套餐组" :visible.sync="changePkgGroupVisible" width="600px"
            @close="changePkgGroupCancel" :close-on-click-modal="false">
            <el-form ref="pkgGroupForm" :model="pkgGroupForm" label-width="120px">
                <el-form-item label="原套餐组名称：">
                    <span>{{ cardInfo.basePkgGroupName }}</span>
                </el-form-item>
                <el-form-item label="新套餐组名称：" prop="newPkgGroup">
                    <el-select v-model="pkgGroupForm.newPkgGroup" filterable>
                        <el-option v-for="item in allowPkgGroup" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="pkgGroupForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changePkgGroupCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgGroupHandler">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="变更卡状态" :visible.sync="changeStateVisible" width="600px"
            @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm" :rules="changeStateRules" label-width="100px">

                <el-form-item label="类型：" prop="state">
                    <el-select v-model="changeStateForm.state" clearable>
                        <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description"
                            :label="'转' + item.description"></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="changeStateForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="添加优惠券" :visible.sync="changeStateVisible1" width="600px"
            @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm" label-width="100px">
                <el-form-item label="订单号：" prop="orderNo">
                    <el-input v-model="changeStateForm.orderNo" placeholder="(选填) 不填则订单退款不会失效"></el-input>
                </el-form-item>
                <el-form-item label="券价格/元：" prop="price">
                    <el-input v-model="changeStateForm.price" placeholder="(选填) 不填则默认10元"></el-input>
                </el-form-item>
                <el-form-item label="券数量：" prop="priceSize">
                    <el-input v-model="changeStateForm.priceSize" placeholder="(选填) 不填则默认11张券"></el-input>
                </el-form-item>
                <el-form-item label="券名称：" prop="name">
                    <el-input v-model="changeStateForm.name" placeholder="(选填) 不填则默认券名称位 优惠券"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler1">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 订单详情 -->
        <el-dialog :append-to-body="true" title="订单详情" :visible.sync="orderDetailVisible" width="600px"
            :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{ orderDetailForm.orderNo }}</span>
            </div>

            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{ orderDetailForm.packageName }}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{ orderDetailForm.priceRmb }} 元</span>
            </div>

            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{ orderDetailForm.createTime }}</span>
            </div>

            <div class="lineInDialog">
                <label>备注：</label>
                <div v-html="orderDetailForm.remark">
                </div>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :append-to-body="true" title="添加叠加包" :visible.sync="overlayPkgVisible" width="600px"
            @close="overlayPkgCancel" :close-on-click-modal="false">
            <el-form ref="overlayPkgForm" :model="overlayPkgForm" :rules="overlayPkgRules" label-width="100px">
                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="overlayPkgForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in overlayPkgGroup" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="overlayPkgForm.packageId" clearable>
                        <el-option v-for="item in overlayPkgList" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="overlayPkgForm.isNextMonth" clearable>
                        <el-option value=0 label="本月生效"></el-option>
                        <el-option value=1 label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="overlayPkgForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="overlayPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddOverlayPkg">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="增加余额账户" :visible.sync="transferBalanceVisible1" width="600px"
            @close="closeTransferBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="dataForm" :model="dataForm" label-width="120px">

                <!-- <el-form-item label="卡号" prop="iccid">
                    <el-input v-model.trim="dataForm.iccid" placeholder="ICCID或虚拟号" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="金额/元" prop="amount">
                    <el-input v-model.trim="dataForm.amount" placeholder="输入要添加的账户金额" clearable></el-input>
                </el-form-item>
                <el-form-item label="余额密码" prop="payPass">
                    <el-input v-model.trim="dataForm.payPass" placeholder="非必填--默认6个0" clearable></el-input>
                </el-form-item>
                <el-form-item label="绑定手机号" prop="mobile">
                    <el-input v-model.trim="dataForm.mobile" placeholder="非必填" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model.trim="dataForm.remark" placeholder="请输入备注" :rows="3" show-word-limit
                        :maxlength="50" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeTransferBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="transferBalanceToOther1()">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {
    getSimDetailInfo, getOneSIMOrderList, addPkg, getPkgList, getAllowChangePkgGroup, toChangePkgGroup, changePkgEndTime,
    delayPkgEndTime, delayPkgEndTime1, toNewCard, simDiagnosis, updateState, stopSim, resetSim, getFluxDetailList,
    getSimStopStartRecordList, changeCardState, getOverlayPkgOptions, getRealName, getSimStopStartRecordList1
} from '@/api/sim.js'
import { modifyOrderRemark } from '@/api/order.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
import '@/styles/txt.wav.css'

export default {
    data() {
        return {
            isExpandAll: false,
            cardDetailsForm: {
                iccid: ''
            },
            dataForm: {
                iccid: '',
                mobile: '',
                payPass: '',
                remark: null,
                amount: ''
            },
            showDetail: false,
            cardInfo: {
                isUserAuth: '',
                userName: '',
                idCard: '',
                userPhone: '',

                remark: '',
                id: '',
                virtualNo: '',
                supplierTypeCode: '',
                iccid: '',
                priceName: '',
                agentName: '',
                userCity: '',
                simAmount: '',
                supplierName: '',
                alias: '',
                cardTypeName: '',
                endTime: '',
                intoNo: '',
                cardState: '',
                flowRatePool: '',
                basePkgGroupName: '',
                cardStateName: '',
                flowRatePercent: null,
                simPackageList: [],
                monthTotal: null,
                changeStateRemark: "",
            },
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            addPkgVisible: false,       //添加套餐
            pkgList: [],
            addPkgForm: {
                isNextMonth: '0',
                packageId: '',
                toBuy: 1,
                remark: ''
            },
            addPkgFormIsNextMonth: false,
            toNewCardVisible: false,    //转新卡
            toNewCardForm: {
                iccid: '',
                moveType: '1',
                remark: ''
            },
            stateRecordVisible: false,  //停复机记录
            stateRecordVisible1: false,  //停复机记录
            'tableData_record': [],
            'currentPage_record': 1,
            'pageSize_record': 10,
            'total_record': 0,
            'tableData_record1': [],
            'currentPage_record1': 1,
            'pageSize_record1': 10,
            'total_record1': 0,
            fluxVisible: false,         //流量使用详情
            'tableData_flux': [],
            'currentPage_flux': 1,
            'pageSize_flux': 10,
            'total_flux': 0,
            endTimeVisible1: false, //修改流量信息
            endTimeVisible: false,     //修改过期时间
            endTimeForm: {
                type: '1',
                pkgId: '',
                oldTimeString: '',
                newTimeString: '',
                dayNum: 0,
                remark: '',
                total: '',
                use: '',
                newEndString: ''
            },
            changePkgGroupVisible: false, //变更套餐组
            allowPkgGroup: [],
            pkgGroupForm: {
                newPkgGroup: '',
                remark: ''
            },
            changeStateVisible: false,    //变更卡状态
            changeStateVisible1: false,    //变更卡状态
            cardStateOption: [],
            changeStateForm: {
                state: '',
                remark: '',
                name: '',
                price: '',
                priceSize: '',
                orderNo: '',
                iccid: ''
            },
            overlayPkgVisible: false,
            overlayPkgForm: {
                typeGroupId: '',
                packageId: '',
                isNextMonth: '',
                remark: ''
            },
            overlayPkgGroup: [],
            overlayPkgList: [],
            cardDetailsRules: {
                iccid: [{ required: true, message: '请输入ICCID号或接入号', trigger: 'blur' }]
            },
            addPkgRules: {
                packageId: [{ required: true, message: '请选择要充值的套餐', trigger: 'blur' }],
                toBuy: [{ required: true, message: '请选择', trigger: 'change' }]
            },
            toNewCardRules: {
                iccid: [{ required: true, validator: this.checkIccid, trigger: 'change' }]
            },
            changeStateRules: {
                state: [{ required: true, message: '请选择变更状态', trigger: 'blur' }],
                remark: [{ required: true, message: '请选择输入变更原因', trigger: 'blur' }],
            },
            overlayPkgRules: {

            },
            orderDetailVisible: false,
            orderDetailForm: {},
            transferBalanceVisible1: false,
        }
    },
    // 指令
    directives: {
        focus: {
            inserted: function (el) {
                function getFocus(element) {
                    if (element.nodeName === 'INPUT') {
                        element.focus();
                        return;
                    } else if (element.children.length > 0) {
                        for (let i = 0; i < element.children.length; i++) {
                            getFocus(element.children[i])
                            return;
                        }
                    }
                }
                getFocus(el);
            }
        }
    },
    methods: {
        //复制
        copyOrderId() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
                this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },


        updateLimitNumber(iccid) {
            var data = {
                iccid: this.cardInfo.iccid,
                remark: this.cardInfo.remark
            }
            common.sysRequest("sim/update/remark", data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        activeNo() {
            common.sysRequest("sim/activity/noBind", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        },
        selectStopResult() {
            common.sysRequest("sim/select/stop", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        },
        transferBalanceToOther1() {
            this.dataForm.iccid = this.cardInfo.iccid;
            common.sysRequest("sysUser/add/account", this.dataForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.closeTransferBalanceDialog();
                    this.cardInfo.simAmount = Number(this.cardInfo.simAmount) + Number(this.dataForm.amount);
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));

        },
        closeTransferBalanceDialog() {
            this.transferBalanceVisible1 = false;
        },
        showToNewCard1() {
            this.transferBalanceVisible1 = true;
        },
        noBIndSIm() {
            var data = {
                iccid: this.cardInfo.iccid
            };
            common.sysRequest("external/ctcc/no/bind", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('解绑成功！');
                } else {
                    this.$message.error(res.data.message);
                }

            })

        },
        addPkgCancel() {
            this.addPkgVisible = false;
            this.$refs.addPkgForm.resetFields();
        },
        endTimecancel() {
            this.endTimeVisible = false;
            this.$refs.endTimeForm.resetFields();
        },
        endTimecancel1() {
            this.endTimeVisible1 = false;
            this.$refs.endTimeForm.resetFields();
        },
        toNewCardCancel() {
            this.toNewCardVisible = false;
            this.$refs.toNewCardForm.resetFields();
        },
        changePkgGroupCancel() {
            this.changePkgGroupVisible = false;
            this.$refs.pkgGroupForm.resetFields();
        },
        changeStateCancel() {
            this.changeStateVisible = false;
            this.changeStateVisible1 = false;
            this.$refs.changeStateForm.resetFields();
        },
        overlayPkgCancel() {
            this.overlayPkgVisible = false;
            this.$refs.overlayPkgForm.resetFields();
        },
        getSimDetailInfoHandler(iccid, $event) {
            if ($event) {
                Object.assign(this.$data, this.$options.data());  //重置为初始值
                this.cardDetailsForm.iccid = iccid
            }
            this.$refs.cardDetailsForm.validate(valid => {
                if (valid) {
                    var data = {
                        iccid
                    }
                    getSimDetailInfo(data).then(res => {
                        if (res.data.code == 200) {
                            this.showDetail = true;
                            var result = res.data;
                            for (var key in this.cardInfo) {
                                this.cardInfo[key] = res.data.data[key];
                            }
                            this.$nextTick(() => {
                                this.updateStateHandler(iccid, false);
                                this.showDetail = true;
                            })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    this.getOneSIMOrderListHandler();
                }
            })
        },
        showToNewCard12() {
            this.$confirm("此操作会把卡的余额，套餐，订单，绑定手机记录全部删除。确定要操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('pkg/delete/pkg/iccid', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },
        showToNewCard123() {
            var data = {
                iccid: this.cardInfo.iccid
            }
            common.sysRequest('external/deleteSysAuth', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    // this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showToNewCard124() {
            var data = {
                iccid: this.cardInfo.iccid
            }
            common.sysRequest('sim/deleteOut', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    // this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showToNewCard125() {
            this.$confirm("确定要操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('sim/deleteUserPhone', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },

        showToNewCard126() {
            this.$confirm("确定要操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('sim/deleteUserPhoneCache', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },
        showToNewCard127() {
            this.$confirm("确定要操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('sim/deletePkgs', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },
        getOneSIMOrderListHandler() {
            var data = {
                perPageNum: this.pageSize,
                pageNo: this.currentPage,
                iccid: this.cardDetailsForm.iccid
            }
            getOneSIMOrderList(data).then(res => {  //获取往期来往订单
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData = result.resultList;
                    this.total = result.totalNum;
                    this.currentPage = result.pageNo;
                    this.pageSize = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },

        changeAddPkgFormItem(value) {
            for (let i = 0; i < this.pkgList.length; i++) {
                if (value == this.pkgList[i].id) {
                    this.addPkgFormIsNextMonth = this.pkgList[i].type == 2 || this.pkgList[i].type == 10 || this.pkgList[i].type == 14 || this.pkgList[i].type == 6 || this.pkgList[i].type == 17
                        || this.pkgList[i].type == 25;
                }
            }
        },
        updateStateHandler(iccid, showSuccessMsg) {
            var data = { iccid };
            updateState(data).then(res => {
                if (res.data.code == 200) {
                    if (showSuccessMsg) {
                        this.$message.success(res.data.message);
                    }
                    getSimDetailInfo(data).then(res => {
                        if (res.data.code == 200) {
                            this.showDetail = true;
                            var result = res.data;
                            for (var key in this.cardInfo) {
                                this.cardInfo[key] = res.data.data[key];
                            }
                        }
                    });
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showChangePkgEndTimeHandler(item) {
            this.endTimeVisible = true;
            this.endTimeForm.oldTimeString = item.endTime;
            this.endTimeForm.pkgId = item.id;
        },
        showChangePkgEndTimeHandler1(item) {
            this.endTimeVisible1 = true;
            this.endTimeForm.total = item.flowRate / 1024;
            this.endTimeForm.use = item.usedFlowRate / 1024;
            this.endTimeForm.pkgId = item.id;
        },
        sureChangePkgEndTimeHandler() {
            if (this.endTimeForm.type == 1) {
                var data = {
                    simPkgId: this.endTimeForm.pkgId,
                    newTimeString: this.endTimeForm.newTimeString,
                    remark: this.endTimeForm.remark,
                    newEndString: this.endTimeForm.newEndString
                }
                changePkgEndTime(data).then(res => {
                    if (res.data.code == 200) {
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else if (res.data.code == 400) {
                        this.$message.error(res.data.message);
                    }
                })
            } else {
                var dataP = {
                    simPkgId: this.endTimeForm.pkgId,
                    dayNum: this.endTimeForm.dayNum,
                    remark: this.endTimeForm.remark
                }
                delayPkgEndTime(dataP).then(res => {
                    if (res.data.code == 200) {
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else if (res.data.code == 400) {
                        this.$message.error(res.data.message);
                    }
                })
            }
        },
        sureChangePkgEndTimeHandler1() {
            var dataP = {
                id: this.endTimeForm.pkgId,
                flowRate: this.endTimeForm.total,
                usedFlowRate: this.endTimeForm.use
            }
            delayPkgEndTime1(dataP).then(res => {
                if (res.data.code == 200) {
                    this.endTimeVisible1 = false;
                    this.$message.success('修改流量信息完成！');
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else if (res.data.code == 400) {
                    this.$message.error(res.data.message);
                }
            })

        },
        showAddPkg() {
            var data = {
                iccid: this.cardInfo.iccid
            }
            getPkgList(data).then(res => {
                var result = res.data.data;
                if (res.data.code == 200) {
                    if (result.length > 0) {
                        this.addPkgVisible = true;
                        this.pkgList = result;
                    } else {
                        this.$message.error('该套餐组下无可添加的套餐！')
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureAddPkgHandle() {
            this.$refs.addPkgForm.validate(valid => {
                if (valid) {
                    var data = this.addPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.addPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        stopSimHandler() {
            this.$confirm("您确定要进行停机操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                stopSim(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("停机完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        if (res.data) {
                            this.$message.error(res.data.message);
                        }
                    }
                })
            })
        },
        resetSimHandler() {
            this.$confirm("您确定要进行复机操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                resetSim(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("复机完成！")
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            })
        },
        showChangePkgGoupHandler() {
            this.changePkgGroupVisible = true;
            var data = {
                basePkgGroup: this.cardInfo.basePkgGroup,
                iccid: this.cardInfo.iccid
            }
            getAllowChangePkgGroup(data).then(res => {
                if (res.data.code == 200) {
                    this.allowPkgGroup = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureChangePkgGroupHandler() {
            var data = {
                basePkgGroup: this.pkgGroupForm.newPkgGroup,
                iccid: this.cardInfo.iccid,
                remark: this.pkgGroupForm.remark
            }
            toChangePkgGroup(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('变更套餐成功！');
                    this.changePkgGroupVisible = false;
                    this.getSimDetailInfoHandler(this.cardInfo.iccid)
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showToNewCardHandler() {
            this.toNewCardVisible = true;
        },
        sureToNewCardHandler() {
            this.$refs.toNewCardForm.validate(valid => {
                if (valid) {
                    var data = {
                        oldIccid: this.cardInfo.iccid,
                        newIccid: this.toNewCardForm.iccid,
                        moveType: this.toNewCardForm.moveType,
                        remark: this.toNewCardForm.remark
                    }
                    toNewCard(data).then(res => {
                        if (res.data.code == 200) {
                            this.toNewCardVisible = false;
                            this.$message.success('转卡成功！');
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        simDiagnosisHandler() {
            this.$confirm("您确定使用一键诊断功能吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                simDiagnosis(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("诊断完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        stateRecordListHandler() {
            this.stateRecordVisible = true;
            var data = {
                perPageNum: this.pageSize_record,
                pageNo: this.currentPage_record,
                iccid: this.cardInfo.iccid
            }
            getSimStopStartRecordList(data).then(res => {
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData_record = result.resultList;
                    this.total_record = result.totalNum;
                    this.currentPage_record = result.pageNo;
                    this.pageSize_record = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        stateRecordListHandler1() {
            this.stateRecordVisible1 = true;
            var data = {
                perPageNum: this.pageSize_record1,
                pageNo: this.currentPage_record1,
                iccid: this.cardInfo.iccid
            }
            getSimStopStartRecordList1(data).then(res => {
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData_record1 = result.resultList;
                    this.total_record1 = result.totalNum;
                    this.currentPage_record1 = result.pageNo;
                    this.pageSize_record1 = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        getFluxDetailListHandler() {
            this.fluxVisible = true;
            var data = {
                perPageNum: this.pageSize_flux,
                pageNo: this.currentPage_flux,
                simId: this.cardInfo.id
            }
            getFluxDetailList(data).then(res => {
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData_flux = result.resultList;
                    this.total_flux = result.totalNum;
                    this.currentPage_flux = result.pageNo;
                    this.pageSize_flux = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showChangeCardStateHandler() {
            common.sysRequest('sim/state/dict', {}, 'get').then(res => {
                if (res.data.code == 200) {
                    this.cardStateOption = res.data.data;
                    this.changeStateVisible = true;
                } else {
                    this.$message.error(res.data.message);
                }
            })

        },
        sureChangeStateHandler1() {
            this.changeStateForm.iccid = this.cardInfo.iccid;
            common.sysRequest('import/sim/state/insert/price', this.changeStateForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.changeStateVisible1 = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showChangeCardStateHandler1() {
            this.changeStateVisible1 = true;

        },
        sureChangeStateHandler() {
            this.$refs.changeStateForm.validate(valid => {
                if (valid) {

                    var data = this.changeStateForm;
                    data.id = this.cardInfo.id;
                    changeCardState(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                            this.changeStateVisible = false;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        //跳转至【流量轮询详情】页面
        toFluxPollDetail(iccid) {
            this.$store.commit('menu/setFluxPollDetailIccid', iccid);
            this.$store.commit('menu/setFluxPollDetailTaskNo', "");
            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '流量轮询详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/fluxPollDetail"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getOneSIMOrderListHandler();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getOneSIMOrderListHandler();
        },
        handleSizeChangeRecord(val) {
            this.pageSize_record = val;
            this.stateRecordListHandler();
        },
        handleCurrentChangeRecord(val) {
            this.currentPage_record = val;
            this.stateRecordListHandler();
        },

        handleSizeChangeRecord1(val) {
            this.pageSize_record1 = val;
            this.stateRecordListHandler1();
        },
        handleCurrentChangeRecord1(val) {
            this.currentPage_record1 = val;
            this.stateRecordListHandler1();
        },
        handleSizeChangeFlux(val) {
            this.pageSize_flux = val;
            this.getFluxDetailListHandler();
        },
        handleCurrentChangeFlux(val) {
            this.currentPage_flux = val;
            this.getFluxDetailListHandler();
        }, showOrderDetailHandler(row) {//查看订单详情
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
            return;
        }, modifyOrderInfoHandler(row) {//修改订单备注 
            if (row.remark.length == '') {
                return;
            }
            let param = {
                id: row.id,
                remark: row.remark
            }
            modifyOrderRemark(param).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);

                } else {
                    this.$message.error(res.data.message);
                }
            });

        },
        showAddOverlayPkg() {
            this.overlayPkgVisible = true;
            getOverlayPkgOptions({}).then(res => {
                if (res.data.code == 200) {
                    this.overlayPkgGroup = res.data.data;
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        changeHandler() {
            this.overlayPkgForm.packageId = '';
            var data = {
                typeGroupId: this.overlayPkgForm.typeGroupId
            }
            common.getPkgOfGroupCom(this, 'overlayPkgList', data);
        },
        IllusoryCardState(row) {
            if (row.cardState >= 5 && row.cardState != 11) {//异常或违禁
                if (row.cardState == 12) {
                    return '注销'
                } else if (row.cardState == 9) {
                    return '故障'
                }
                return '正常';
            } else {
                return row.cardStateName;
            }
        },
        sureAddOverlayPkg() {
            this.$refs.overlayPkgForm.validate(valid => {
                if (valid) {
                    var data = this.overlayPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.overlayPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },

        isExpiredTime(str) {
            let d = new Date(str);
            if (d < new Date()) {
                return true;
            }
            return false;
        },
        showAddRealNameSearch() {//点击电信实名查询
            let data = {
                iccid: this.cardDetailsForm.iccid,
                intoNo: this.cardInfo.intoNo
            }
            getRealName(data).then(res => {
                if (res.data.code == 200) {
                    this.$alert('已实名', {
                        confirmButtonText: '确定'
                    })
                } else {
                    this.$alert('未实名', {
                        confirmButtonText: '确定'
                    })
                }
            })
        },
        //重置流量
        resetFlow() {
            this.$confirm('此功能仅供用户流量套餐异常时操作，不支持跨月套餐，仅支持小象卡，确定要重置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let param = {
                    id: this.cardInfo.id,
                    iccid: this.cardInfo.iccid
                }

                common.sysRequest('pkg/update/pkg', param, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => { });
        },
    },
    created() {

    },
    mounted() {
        let fromPage = this.$store.state.menu.fromPage;
        let fromPageIccid = this.$store.state.menu.fromPageIccid;
        if (fromPage == 'cardMgt' || fromPage == 'orderMgt') {
            this.cardDetailsForm.iccid = fromPageIccid;
            this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }
    },

    computed: {
        getSum: function () {
            let sum = 0;
            for (let i = 0; i < this.cardInfo.simPackageList.length; i++) {
                sum += Number(this.fluxMtoG(this.cardInfo.simPackageList[i].usedRealFlowRate));
            }
            return this.money_format(sum, 2);
        }
    },
}
</script>

<style lang="less">
#cardDetails {
    font-size: 12px;

    .section1,
    .section2,
    .section3,
    .section4,
    .section5 {
        margin-bottom: 30px;
        padding-left: 8px;
    }

    .section2 {
        .el-row {
            line-height: 40px;
        }
    }

    .section3 {
        .el-row {
            line-height: 34px;
            margin-bottom: 20px;
        }

        .progressOuter {
            line-height: normal;

            .el-progress {
                margin: 5px 0;
            }
        }

        .pOuter {
            margin-top: -10px;
        }
    }

    .section4 {
        div {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .el-button {
                flex: 1;
                margin-bottom: 10px;
            }
        }
    }

    h4 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;
    }

    /*新增套餐*/
    .pkgName {
        display: block;

        label.el-radio {
            width: 50%;
            margin: 10px 0 15px 0;
        }
    }

    .span-defined {
        margin-right: 20px;
    }

    .font-defined {
        font-size: 24px;
    }

    .green {
        color: #309200;
    }

    .red {
        color: #c71c1c;
    }

    .dark {
        color: #7d7d5d;
    }

    .text-animation-default {
        animation: text-animation 3s infinite ease-out;
    }

    @keyframes text-animation {
        0% {
            transform: translateY(-30px);
        }

        1.5% {
            transform: translateY(30px);
        }

        3% {
            transform: translateY(-30px);
        }

        4.5% {
            transform: translateY(30px);
        }

        6% {
            transform: translateY(-30px);
        }

        7.5% {
            transform: translateY(30px);
        }

        9% {
            transform: translateY(-30px);
        }

        10.5% {
            transform: translateY(30px);
        }

        12% {
            transform: translateY(-30px);
        }

        13.5% {
            transform: translateY(30px);
        }

        15% {
            transform: translateY(-30px);
        }

        50% {
            transform: scale(1.6) translateY(30px);
        }

        100% {
            transform: scale(1.6) translateY(30px);
        }
    }
}
</style>

